<template>
<section class="input-container">
    <div class="label">
        <p><i class="icon-required" v-if="transProp.validations.presence === '1'">*</i>{{transProp.label}}:</p>
        <van-icon name="question-o" class="question" v-if="transProp.notes" @click="showNotes" />
    </div>
    <div class="inp-f" @click="showSelect">
        <input type="text" class="inp-s" v-model="value" @input="validate" disabled>
        <van-icon name="arrow-down" class="arrow-down" />
    </div>
    <div class="form-error" v-show="showError">
        {{transProp.label}}不可为空
    </div>
    <div class="tip">{{transProp.notes}}</div>
    <van-action-sheet v-model="show" :actions="actions" @select="onSelect" />
</section>
</template>

<script>
import { ActionSheet, Icon } from "vant";
export default {
  props: {
    transProp: Object,
    index: Number
  },
  components: {
    "van-action-sheet": ActionSheet,
    "van-icon": Icon
  },
  data() {
    return {
      show: false,
      value: "",
      showError: false,
      actions: [
        {
          name: "选项2"
        },
        {
          name: "选项1"
        },
        {
          name: "选项3",
          subname: "描述信息"
        }
      ]
    };
  },
  methods: {
    showNotes() {
      this.$emit("input", this.index);
    },
    collectOptions() {
      let options = {
        code: this.transProp.code,
        value: this.value
      };
      return options;
    },
    onSelect(item) {
      // 默认情况下，点击选项时不会自动关闭菜单
      // 可以通过 close-on-click-action 属性开启自动关闭
      this.show = false;
      this.value = item.name;
    },
    showSelect(item) {
      this.show = true;
    },
    validate() {
      if (this.transProp.required) {
        if (!this.value) {
          this.showError = true;
          return { label: this.transProp.label, boo: true };
        } else {
          this.showError = false;
          return { label: this.transProp.label, boo: false };
        }
      } else {
        return { label: this.transProp.label, boo: false };
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.input-container {
  .label {
    display: flex;
    align-items: center;
    justify-content: space-between;

    .question {
      color: #999090;
      font-size: 32px;
    }
  }

  .inp-f {
    margin: 8px 0;
    position: relative;

    .inp-s {
      color: #999090;
    }

    .arrow-down {
      font-size: 38px;
      color: #999090;
      position: absolute;
      right: 18px;
      top: 50%;
      transform: translateY(-50%);
    }
  }
}
</style>
